"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var EyebrowLabel = function EyebrowLabel(_ref) {
    var children = _ref.children, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? 'center' : _ref$alignment, _ref$isDrawer = _ref.isDrawer, isDrawer = _ref$isDrawer === void 0 ? false : _ref$isDrawer;
    return !!children ? /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        alignment: alignment
    }, /*#__PURE__*/ react_1.default.createElement(Label, {
        alignment: alignment,
        isDrawer: isDrawer
    }, children)) : null;
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "EyebrowLabel__Wrapper",
    componentId: "sc-8090fh-0"
})(["position:relative;display:flex;flex-direction:row;justify-content:flex-start;width:100%;margin-bottom:10px;", " text-align:left;", "{justify-content:", ";margin-bottom:16px;text-align:", ";&::before,&::after{display:", ";}&::before{position:absolute;z-index:-2;left:0;top:50%;height:1px;width:calc((100% - 50px) / 2);background:", ";opacity:0.24;content:'';}&::after{position:absolute;z-index:-2;right:0;top:50%;height:1px;width:calc((100% - 50px) / 2);background:", ";opacity:0.24;transform:rotateZ(180deg);content:'';}}", "{margin-bottom:24px;}"], _theme_1.type.labelSmall, _utils_1.mediaQuery('tablet'), function (props) {
    return props.alignment === 'center' ? 'center' : 'flex-start';
}, function (props) {
    return props.alignment;
}, function (props) {
    return props.alignment === 'center' ? 'block' : 'none';
}, _theme_1.gradient.buttonLine, _theme_1.gradient.buttonLine, _utils_1.mediaQuery('desktop'));
var Label = styled_components_1.default.div.withConfig({
    displayName: "EyebrowLabel__Label",
    componentId: "sc-8090fh-1"
})(["background-color:", ";width:fit-content;height:100%;", "{", "}", "{", "}", "{", "}"], function (props) {
    return props.isDrawer ? _theme_1.palette.snow : _theme_1.palette.ivory;
}, _utils_1.mediaQuery('tablet'), function (props) {
    return props.alignment === 'center' && "\n      padding: 0 16px;\n    ";
}, _utils_1.mediaQuery('laptop'), function (props) {
    return props.alignment === 'center' && "\n      padding: 0 24px;\n    ";
}, _utils_1.mediaQuery('desktop'), function (props) {
    return props.alignment === 'center' && "\n      padding: 0 32px;\n    ";
}); // Typing
exports.default = EyebrowLabel;
